<template>
  <div class="overview">
    <div class="overview-info">
      <div class="dashboard-container">
        <div class="top-overview">
          <div class="balance">
            <p>Current Balance</p>
            <div class="d-flex align-items-center">
              <span class="usd me-1">$</span>
              <h3>{{ $auth.user().earnings_current|formatCents }}</h3>
            </div>
          </div>
          <div class="earnings d-flex align-items-lg-center">
            <div class="today">
              <p>Today’s earnings</p>
              <div class="d-flex align-items-center">
                <span class="usd me-1">$</span>
                <h3>{{ $auth.user().earnings_today|formatCents }}</h3>
              </div>
            </div>
            <div class="all">
              <p>All time earnings</p>
              <div class="d-flex align-items-center">
                <span class="usd me-1">$</span>
                <h3>{{ $auth.user().earnings_total|formatCents }}</h3>
              </div>
            </div>
          </div>
          <div class="request-payout">
            <!-- Button trigger modal -->
            <button type="button" class="main-btn request-btn" data-bs-toggle="modal"
              data-bs-target="#requestPayout">
                <span>
                  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M23.4705 17.6V8.00001C23.4705 6.68001 22.3864 5.60001 21.0615 5.60001H4.19806C2.87308 5.60001 1.789 6.68001 1.789 8.00001V17.6C1.789 18.92 2.87308 20 4.19806 20H21.0615C22.3864 20 23.4705 18.92 23.4705 17.6ZM21.0615 17.6H4.19806V8.00001H21.0615V17.6ZM28.2886 22.4V9.20001H25.8796V22.4H5.40259V24.8H25.8796C27.2045 24.8 28.2886 23.72 28.2886 22.4Z"
                          fill="white" />
                    <path
                        d="M13.4579 14.5464C13.496 14.3108 13.4522 14.1073 13.3266 13.9356C13.201 13.764 12.9431 13.6008 12.5528 13.4461C12.1626 13.2913 11.84 13.1382 11.5849 12.9868C10.8045 12.5224 10.4428 11.9117 10.4999 11.1546C10.5418 10.5758 10.7873 10.1022 11.2366 9.73375C11.6858 9.3653 12.274 9.14742 13.0011 9.08013L13.2352 8H14.1318L13.8919 9.11041C14.4706 9.21809 14.9113 9.47382 15.2139 9.8776C15.5166 10.2814 15.6584 10.8046 15.6394 11.4473L14.0233 11.4423C14.069 10.6482 13.8044 10.2461 13.2295 10.236C12.9288 10.2292 12.6756 10.3108 12.47 10.4808C12.2645 10.6507 12.1407 10.8736 12.0989 11.1495C12.0646 11.3649 12.1074 11.555 12.2273 11.7199C12.3473 11.8848 12.5776 12.0395 12.9183 12.1842C13.259 12.3289 13.5455 12.4635 13.7777 12.588C14.6876 13.0726 15.1121 13.722 15.0512 14.5363C15.0093 15.1218 14.7647 15.5945 14.3174 15.9546C13.8701 16.3146 13.2771 16.5283 12.5386 16.5956L12.3159 17.6H11.425L11.6477 16.5905C10.9777 16.503 10.4666 16.2482 10.1145 15.8259C9.76231 15.4036 9.59765 14.8627 9.6205 14.2032L11.2309 14.2082C11.2118 14.6154 11.287 14.9216 11.4564 15.1268C11.6258 15.3321 11.8799 15.4381 12.2188 15.4448C12.5424 15.4515 12.8184 15.3716 13.0468 15.205C13.2752 15.0385 13.4123 14.8189 13.4579 14.5464Z"
                        fill="white" />
                  </svg>
                </span>
              <span>Request Payout</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <RequestPayout/>
    <AddDevice/>

    <div class="dashboard-container">
      <div class="overview-body">
        <div class="earninge-graph">
          <div class="row">
            <div class="col-md-8 d-flex">
              <div class="earnings-chart box-style w-100">
                <div class="chart-info d-flex align-items-center justify-content-between">
                  <h3>Earnings</h3>
                  <div class="select">
                    <select name="transaction-period" v-model="form.period">
                      <option value="7">7-days</option>
                      <option value="14">14-days</option>
                      <option value="30">30-days</option>
                    </select>
                  </div>
                </div>
                <div class="graph text-center">
                  <apexchart height="400" :options="chartOptions" :series="series"></apexchart>
                </div>
              </div>
            </div>
            <div class="col-md-4 d-flex">
              <div class="devices w-100">
                <div class="title">
                  <h3>Devices</h3>
                </div>
                <ul>
                  <li v-for="d in devices" :key="d.id">
                    <div class="left">
                      <div v-html="iconOS(d.os)"></div>
                      <span>{{ formatOS(d.os) }} {{ d.version }}</span>
                    </div>
                    <div class="date">{{ formatDateFromNow(d.online) }}</div>
                  </li>
                </ul>
                <button class="add-device" type="button" data-bs-toggle="modal" data-bs-target="#addDevice">Add
                  device</button>
              </div>
            </div>
          </div>
        </div>
        <div class="referral-code">
          <div class="row">
            <div class="col-md-5 col-lg-6">
              <div class="share-code">
                <p>Here’s your referral link to share with your friends</p>
                <div class="code text-lowercase">{{ domain() }}/a/{{ $auth.user().referral_code }}</div>
              </div>
            </div>
            <div class="col-md-7 col-lg-6">
              <div class="send-invite">
                <p v-if="!form.inviteSent">Invite your friends and you can earn an extra $5 bonus!</p>
                <p v-else>Invite was sent!</p>
                <validation-observer ref="emailForm">
                  <form @submit.prevent="sendInvite">
                    <input type="email" class="email me-3" v-model="form.email" name="email" id="email"
                           placeholder="Enter email address" />
                    <button type="button" @click="sendInvite">Send Invite</button>
                  </form>
                  <validation-provider name="email" v-slot="{ errors }">
                    <div class="invalid-feedback" style="display: block; text-align: right">{{ errors[0] }}</div>
                  </validation-provider>
                </validation-observer>
              </div>
            </div>
          </div>
        </div>
        <div class="faq">
          <h3>FAQ</h3>
          <div class="accordion" id="accordionExample">
            <div class="accordion-item">
              <h2 class="accordion-header" id="flush-headingOne">
                <button class="accordion-button" type="button" data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseOne" aria-expanded="false"
                        aria-controls="flush-collapseOne">What is CoinSurf and how does it work?</button>
              </h2>
              <div id="flush-collapseOne" class="accordion-collapse collapse show"
                   aria-labelledby="flush-headingOne" data-bs-parent="#accordionExample">
                <div class="accordion-body">CoinSurf is a passive income platform which allows you to earn while leaving the CoinSurf application running in the background.</div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="flush-headingTwo">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">Is there a limit to how much I can earn with CoinSurf?</button>
              </h2>
              <div id="flush-collapseTwo" class="accordion-collapse collapse" aria-labelledby="flush-headingTwo"
                   data-bs-parent="#accordionExample">
                <div class="accordion-body">Absolutely not! You can earn as much money as you want with CoinSurf. As long as your devices are consistently available to share your unused internet and there is demand for network access in your region, you will be able to earn income.</div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="flush-headingThree">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseThree" aria-expanded="false"
                        aria-controls="flush-collapseThree">Will I earn more if I connect multiple devices in one home?</button>
              </h2>
              <div id="flush-collapseThree" class="accordion-collapse collapse"
                   aria-labelledby="flush-headingThree" data-bs-parent="#accordionExample">
                <div class="accordion-body">Not neccessarily. By connecting with multiple devices in the same network, you will have redundancy incase one of your devices goes offline and you want to make sure you are still connected to CoinSurf. However, you can only earn from 1 IP through 1 device at any given moment.</div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="flush-headingFour">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseFour" aria-expanded="false"
                        aria-controls="flush-collapseFour">Does CoinSurf have a mobile application?</button>
              </h2>
              <div id="flush-collapseFour" class="accordion-collapse collapse"
                   aria-labelledby="flush-headingFour" data-bs-parent="#accordionExample">
                <div class="accordion-body">We are working on an Android application which we hope to launch before Q4 of 2022. However due to development limitations with Apple devices, we do not have any plans to release an iOS or iPadOS application in the near future.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {Device} from "@/models"
import {iconOS, formatOS, formatCents, formatDateFromNow} from "@/helpers"
import RequestPayout from "@/components/modals/RequestPayout"
import AddDevice from "@/components/modals/AddDevice"

import API from "@/api"
const api = new API()

export default {
  name: "Overview",
  components: {AddDevice, RequestPayout },
  data() {
    return {
      form: {
        period: 7,
        email: '',
        inviteSent: false
      },
      chartOptions: {
        type: 'line',
        zoom: {
          enabled: false
        },
        tooltip: {
          enabled: false
        },
        chart: {
          id: 'vuechart-example',
          dropShadow: {
            enabled: true,
            color: '#000',
            top: 9,
            left: 3,
            blur: 10,
            opacity: 0.2
          },
          toolbar: {
            show: false
          }
        },
        colors: ['#4263f6', '#859af9'],
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        grid: {
          row: {
            colors: ['#f1f1f1', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        xaxis: {
          categories: [],
        }
      },
      series: [{
        name: "Earnings",
        data: []
      }]
    }
  },
  mounted() {
    this.fetchStats()

    this.$wait.start('devices_fetch')
    api.getDevices()
        .then(r => Device.deleteAll().then(() => Device.insertOrUpdate({
          data: r.data.results
        })))
        .catch(e => console.log(e))
        .finally(() => this.$wait.end('devices_fetch'))
  },
  watch: {
    'form.period': function() {
      this.fetchStats()
    }
  },
  computed: {
    devices() {
      return Device.query().orderBy('online', 'desc').limit(6).get()
    }
  },
  methods: {
    domain() {
      return `${Vue.httpProtocol}://${Vue.host}`
    },
    fetchStats() {
      this.$wait.start('stats_fetch')
      api.getStatistics(this.form.period)
        .then(r => {
          this.chartOptions = {
            type: 'line',
            zoom: {
              enabled: false
            },
            chart: {
              id: 'vuechart-example',
              dropShadow: {
                enabled: true,
                color: '#000',
                top: 9,
                left: 3,
                blur: 10,
                opacity: 0.2
              },
              toolbar: {
                show: false
              }
            },
            colors: ['#4263f6', '#859af9'],
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: 'straight'
            },
            grid: {
              row: {
                colors: ['#f1f1f1', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.5
              },
            },
            xaxis: {
              categories: r.data.labels,
            },
            yaxis: {
              labels: {
                formatter: (value) => {
                  return '$' + formatCents(value)
                }
              },
            }
          }

          this.series = [{
            name: 'Earnings',
            data: r.data.data
          }]
        }).catch(e => console.log(e))
        .finally(() => this.$wait.end('stats_fetch'))
    },
    sendInvite() {
      this.$wait.start('invite_sent')
      api.inviteFriend(this.form.email)
        .then(() => {
          this.form.inviteSent = true
          this.form.email = ''
        })
        .catch(r => this.$refs.emailForm.setErrors(r.response.data))
        .finally(() => this.$wait.end('invite_sent'))
    },
    iconOS(name) {
      return iconOS(name)
    },
    formatOS(name) {
      return formatOS(name)
    },
    formatDateFromNow(date) {
      return formatDateFromNow(date)
    }
  }
}
</script>

<style scoped>

</style>
